import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Cred } from 'src/app/shared/cred';
import { SharedService } from 'src/app/shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { EcwidService } from '../service/ecwid.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth.service';
import companies from '../../../assets/companies.json';
@Component({
  selector: 'auth',
  templateUrl: './auth.template.html',
  styleUrls: ['./auth.style.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AuthService, Cred, SharedService, EcwidService],
  host: {
    class: 'login-page app'
  }
})
export class EcwidAuth implements OnInit{
  shopifyshopcreated: any = false;
  currentUser: String;

  code: String;
  authenticationError: boolean;
  isLoggedin: boolean = false;
  error: string;
  load: boolean = true;
  alias: string;
  company: any = {}
  currentCompany:any;
  constructor(public translate: TranslateService, private http: HttpClient, private _service: AuthService, private _router: Router,
    private cred: Cred, private sharedService: SharedService, private activeRoute: ActivatedRoute, private ecwidService: EcwidService) {
    this.activeRoute.queryParams.subscribe(params => {
      this.code = params['code'];
      console.log("Code:: " + this.code);
    });
    this.getUser().subscribe(
      (data) => {//console.log(data);   
        this.company = data['company']
      },
      (err) => {
        this.load = false;
      });
  }
  

  getUser() {
    return this.http.get('/api/me')
      .pipe(map((res: Response) => res));

  }

  login() {

    this._service.login(this.cred.username, this.cred.password).subscribe(data => {
      this._router.navigate(['']);
      this.isLoggedin = true;
      this._service.logSessionActivity("Login", this.cred.username).subscribe(data => {
        this._router.navigate(['/app']);
        //console.log()
      });
    },
      (err) => {
        this.isLoggedin = false;
        this.error = 'Username and/or password are invalid !';
      },
      () => {
        this.currentUser = this.cred.username;
        this.getUser().subscribe(
          (data) => {//console.log(data);   
            this.company = data['company']
          },
          (err) => {
            this.load = false;
          });
        this.createShop()
      }
    );
  }

  logout() {
    this._service.logout().subscribe();


  }

  ngOnInit() {

    this.currentCompany = companies.find((company)=>company.active)
    //                    


  }
  createShop() {
    this.ecwidService.getStoreInformation(this.code).subscribe((data) => {

      if (!data) {
        window.location.href = 'ecwid/alerte';

      } else {
        this.ecwidService.createShop(this.company, this.alias, data['token'].toString(), data['storeId'].toString()).subscribe(data => {
          if (data) {
            this._router.navigate(['src/app/shops/list']);
          }
        })
      }
    })
  }

}
